import useEmblaCarousel from 'embla-carousel-react'
import { createPortal } from 'react-dom'

import SvgIcon from '@/components/svg-icon/svgIcon'
import { Typography } from '@/components/typography/typography'
import { cn } from '@/libs/tw'
import { translate } from '@/utils/translator'

import { RoomOffer } from '../types'
import { RoomFeatures } from './RoomFeatures'
import { RoomFeatureTags } from './roomFeatureTags'

type RoomDetailsProps = {
	room?: RoomOffer
	roomNumber: number
	onClose: () => void
}

export const RoomDetails = ({ room, roomNumber, onClose }: RoomDetailsProps) => {
	const [emblaRef] = useEmblaCarousel()

	if (!room) return null

	return createPortal(
		<div
			className={cn(
				'fixed inset-0 z-50 flex h-full w-full flex-col gap-24 overflow-auto bg-primary p-24 pb-32 text-textColor'
			)}
		>
			<div className={cn('flex items-center justify-between')}>
				<button
					onClick={onClose}
					className={cn('flex gap-16 rounded-8 border border-textColor px-16 py-8')}
				>
					<SvgIcon
						collectionName="ibe3"
						iconName="arrow-right"
						className="h-16 w-16 rotate-180"
					/>
					<Typography element="p" style="p-ms-bold">
						{translate('room-selection-back')}
					</Typography>
				</button>
				<Typography element="p" style="p-m-bold">
					{`${translate('room-selection-room')} ${roomNumber}`}
				</Typography>
			</div>
			<section className={cn('w-full')}>
				<div className={cn('overflow-hidden')} ref={emblaRef}>
					<div className={cn('flex touch-pan-y gap-16')}>
						{room.images.map((img) => (
							<img
								className={cn(
									'h-[290px] min-w-0 flex-[0_0_290px] rounded-8 object-cover'
								)}
								key={img.title}
								src={img.largeUrl}
								alt={img.alt}
								title={img.title}
							/>
						))}
					</div>
				</div>
			</section>
			<Typography element="h3" style="h3">
				{room.title}
			</Typography>
			<RoomFeatureTags highlights={room.highlights} showAll />
			<RoomFeatures features={room.amenities} description={room.description} />
			<button
				onClick={onClose}
				className={cn(
					'grid w-full grid-cols-[1fr_auto_1fr] rounded-8 border border-textColor p-16'
				)}
			>
				<SvgIcon
					collectionName="ibe3"
					iconName="arrow-right"
					className="h-16 w-16 rotate-180"
				/>
				<Typography element="p" style="p-ms-bold">
					{translate('room-selection-back')}
				</Typography>
			</button>
		</div>,
		document.body
	)
}
